import React from 'react';
import { Select, Space, Tag, Button } from 'antd';
import { MobileOutlined, PlusOutlined } from '@ant-design/icons';
import { useDevice } from '../contexts/DeviceContext';
import { useLocation, useNavigate } from 'react-router-dom';

const DeviceSelector: React.FC = () => {
  const { devices, selectedDevice, setSelectedDevice, loading } = useDevice();
  const navigate = useNavigate();
  const location = useLocation();

  if (devices.length === 0) {
    return (
      <Button 
        type="primary" 
        icon={<PlusOutlined />}
        onClick={() => navigate('/devices')}
        size="small"
      >
        デバイス登録
      </Button>
    );
  }

  return (
    <Space>
      <Select
        value={selectedDevice?.id}
        onChange={(deviceId) => {
          const device = devices.find(d => d.id === deviceId);
          setSelectedDevice(device || null);
          if (!device) {
            return;
          }
          const match = location.pathname.match(/^\/devices\/[^/]+(.*)$/);
          if (match) {
            navigate(`/devices/${device.id}${match[1]}${location.search}`);
            return;
          }
          if (location.pathname === '/audio') {
            navigate(`/devices/${device.id}/audio${location.search}`);
          }
        }}
        loading={loading}
        style={{ minWidth: 200 }}
        placeholder="デバイスを選択"
      >
        {devices.map(device => (
          <Select.Option key={device.id} value={device.id}>
            <Space>
              <MobileOutlined />
              <span>{device.name}</span>
              <Tag 
                color={device.operation_mode === 'realtime' ? 'green' : 'default'}
              >
                {device.operation_mode === 'realtime' ? 'リアルタイム' : 'バッチ'}
              </Tag>
            </Space>
          </Select.Option>
        ))}
      </Select>
    </Space>
  );
};

export default DeviceSelector;
